import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as actions from "../../../actions/serverActions";
import * as componentTypes from "../../../constants/componentTypes";

import ProgressPanel from "./status/ProgressPanel";
import ReconnectPanel from "./status/ReconnectPanel";

class StatusPanel extends Component {
    handleCancelClick = () => {
        this.props.dispatchServerDisconnectAction();
    };

    render() {
        if (this.props.applicationStatus === componentTypes.APPLICATION_STATUS_CLOSING) {
            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.closing" />
                        ...
                    </span>
                </div>
            );
        }

        if (this.props.applicationStatus === componentTypes.APPLICATION_STATUS_RESTORING) {
            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.restoring" />
                        ...
                    </span>
                </div>
            );
        }

        if (this.props.gammaSoftware && this.props.module === null) {
            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.moduleMessage" />
                    </span>
                </div>
            );
        }

        if (this.props.connected === null) {
            if (this.props.activeServer === null) {
                return (
                    <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                        <span style={{textTransform: "capitalize"}}>
                            <Translate value="welcome.loading" />
                            ...
                        </span>
                    </div>
                );
            }

            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.connectingServer" ip={this.props.activeServer.getWebSocketUrl()} />
                        ...
                        <button
                            className="btn btn-primary btn-xs"
                            onClick={this.handleCancelClick}
                            style={{marginLeft: "15px"}}
                        >
                            <Translate value="general.cancel" />
                        </button>
                    </span>
                </div>
            );
        }

        if (this.props.connected === false) {
            return <ReconnectPanel />;
        }

        if (!this.props.licensed) {
            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.licenseVerification" />
                        ...
                    </span>
                </div>
            );
        }

        if (!this.props.compatible || !this.props.compatibleDatabase) {
            return (
                <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                    <span>
                        <Translate value="welcome.compatibilityCheck" />
                        ...
                    </span>
                </div>
            );
        }

        if (this.props.loading > 0) {
            return <ProgressPanel loading={this.props.loading} />;
        }

        return "";
    }
}

const mapStoreToProps = (store) => {
    return {
        applicationStatus: store.navigation.status,
        gammaSoftware: store.module.gammaSoftware,
        module: store.module.name,
        activeServer: store.server.activeServer,
        connected: store.server.connected,
        licensed: store.license.licensed,
        compatibleDatabase: store.server.compatibleDatabase,
        compatible: store.server.compatible,
        loading: store.global.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchServerDisconnectAction: () => {
            dispatch(actions.serverDisconnect());
        }
    };
};

export default StatusPanel = connect(mapStoreToProps, mapDispatchToProps)(StatusPanel);
